import {useEffect, useState} from "react";
import associateServices from "../../../../services";
import GeneralStatsItem from "./item";
import '../index.css'
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import GeneralStatsItemSkeleton from "../../general-debit-stats/web/skeleton-item";
import SlimSelect from 'slim-select'
import GeneralStatsWebHighRollers from "./high-rollers";

const GeneralStatsWeb = () => {

    const {t} = useTranslation()
    const [activeType, setActiveType] = useState('all-bets')
    const {authenticated} = useSelector(state => state.authenticationReducer)
    const [searchParams, setSearchParams] = useSearchParams()
    const [loading, setLoading] = useState(true)
    const [limit, setLimit] = useState(10)
    const [data, setData] = useState([])
    const [statTypes, setStatTypes] = useState(['all-bets', 'high-rollers', 'high-winners'])

    useEffect(() => {
        setStatTypes(prevState => authenticated && !prevState?.includes('my-bets') ? ['my-bets', ...prevState] :
            prevState?.filter(i => i !== 'my-bets'))
    }, [authenticated])


    useEffect(() => {
        new SlimSelect({
            select: '#select-count',
            events: {
                afterChange: newVal => setLimit(newVal[0].value)
            },
            settings: {
                showSearch: false,
            }
        });
    }, [])

    const handleApiResponse = res => {
        setData(res?.data || [])
        setLoading(false)

    }

    const handleBet = value => {
        const bet = JSON.parse(value)
        setData(prevState => [bet, ...prevState].slice(0, limit))
    }


    useEffect(() => {
        if (activeType) {
            setData([])
            setLoading(true)

            associateServices.getCasinoTableDebits({
                type: activeType,
                limit
            }).then(handleApiResponse)
        }
    }, [activeType, limit])


    useEffect(() => {

        if (window?.tcpSocket?.connected && activeType === 'all-bets') {

            window?.tcpSocket?.emit('join', `PUBLIC~${localStorage.getItem('w_id')}`)

            window?.tcpSocket?.off('bet').on('bet', handleBet)
            // window?.tcpSocket?.off('win').on('win', handleWin)

            return () => {
                window?.tcpSocket?.emit('leave', `PUBLIC~${localStorage.getItem('w_id')}`)
            }
        } else if (window?.tcpSocket?.connected && activeType === 'mybets') {
            window?.tcpSocket?.off('my-bet').on('my-bet', handleBet)

            return () => {
                window?.tcpSocket?.off('my-bet')
            }
        }

    }, [activeType, window?.tcpSocket?.connected])

    const handleBetDetail = bet => {
        searchParams.append('modal', 'bet')
        searchParams.append('reference', `${bet.type ?? 'casino'}:${bet.id}`)
        setSearchParams(searchParams)
    }


    const handleUserDetail = bet => {

        if (!bet?.customer?.is_public)
            return false

        searchParams.append('modal', authenticated ? 'statistics' : 'login')
        if (authenticated)
            searchParams.append('user', bet?.customer?.username)

        setSearchParams(searchParams)


    }


    return (
        <div className="section">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="table-wrap">
                            <div className="table-wrap__head">
                                <ul
                                    className="nav nav-tabs tabs-nav"
                                    id="tabs-nav"
                                    role="tablist"
                                >
                                    {
                                        statTypes.map(type => (

                                            <li key={type} className="nav-item" role="presentation">
                                                <button
                                                    onClick={e => setActiveType(type)}
                                                    className={`tabs-nav__btn ${type === activeType ? 'active' : ''}`}
                                                    type="button"

                                                >
                                                    {t(`stats.types.${type}`)}
                                                </button>
                                            </li>


                                        ))
                                    }
                                </ul>
                                <select
                                    name="lines"
                                    id="select-count"
                                    className="table-wrap__select"
                                    value={limit}
                                    onChange={e => setLimit(e.target.value)}
                                >
                                    <option value={'10'}>10</option>
                                    <option value={'15'}>15</option>
                                    <option value={'20'}>20</option>
                                </select>
                            </div>

                            {
                                activeType === 'high-rollers' || activeType === 'high-winners' ?
                                    <GeneralStatsWebHighRollers
                                        {...{
                                            data,
                                            limit,
                                            loading,
                                            handleUserDetail
                                        }}
                                    /> :
                                    <div className="tab-content">
                                        <div className="tab-pane fade show active">
                                            {
                                                <div className="table-responsive">
                                                    <table className="xtable">
                                                        <thead>
                                                        {
                                                            loading ? <GeneralStatsItemSkeleton/> :
                                                                <tr>
                                                                    {/*<th>#</th>*/}
                                                                    <th>{t(`stats.table.game`)}</th>
                                                                    <th>{t(`stats.table.user`)}</th>
                                                                    <th>{t(`stats.table.time`)}</th>
                                                                    <th className="text-right">{t(`stats.table.bet`)}</th>
                                                                    <th className="text-right">{t(`stats.table.multiplier`)}</th>
                                                                    <th>{t(`stats.table.profit`)}</th>
                                                                </tr>
                                                        }

                                                        </thead>
                                                        <tbody>

                                                        {
                                                            loading ? Array.from({length: limit}).map((_, index) =>
                                                                    <GeneralStatsItemSkeleton key={index}/>) :
                                                                data?.map((stat, i) => <GeneralStatsItem stat={stat}
                                                                                                         handleBetDetail={handleBetDetail}
                                                                                                         handleUserDetail={handleUserDetail}
                                                                                                         key={i}/>)
                                                        }

                                                        </tbody>
                                                    </table>
                                                </div>
                                            }
                                        </div>

                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}

export default GeneralStatsWeb
